import { StylesConfig } from 'react-select';

export const bookingsFilterStyles: StylesConfig = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: 'transparent',
        border: 'solid 2px black',
        borderRadius: '1rem',
        boxShadow: 'none',
        height: '100%',
        '&:hover': {
            borderColor: 'black !important',
            boxShadow: '2px 1px 1px #90a0b7 !important',
        },
        ...(state.isFocused && {
            borderColor: 'black !important',
            boxShadow: '2px 1px 1px #90a0b7 !important',
        }),
    }),
    container: (provided) => ({
        ...provided,
        minWidth: '14rem',
        height: '2rem',
    }),
    valueContainer: (provided) => ({
        ...provided,
        height: '100%',
        padding: '0 1rem',
    }),
    input: (provided) => ({
        ...provided,
        height: '100%',
    }),
    menu: (provided) => ({
        ...provided,
        minWidth: '18rem',
    }),
    menuList: (provided) => ({
        ...provided,
        minWidth: '18rem',
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        height: '100%',
    }),
    singleValue: (provided) => ({
        ...provided,
        height: '100%',
        lineHeight: '1.75rem',
        maxWidth: '10.75rem',
        fontWeight: 500,
    }),
};

export const MAX_TWO_NUMBERS_MAX_TWO_DECIMALS_REGEX = new RegExp('^[0-9]{1,2}(\\.[0-9]{1,2})?$');
